// extracted by mini-css-extract-plugin
export default {"actions":"styles-module__actions__src-labstep-web-components-ProtocolCollection-Card-Overview-_yMsU3"};